import { View, ViewModel } from "binder";
import { SelectorBaseView } from "src/common/reusableComponents/selectorBase/selectorBase-view";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";

export class ToolModelsForToolTypeSelector extends SelectorBaseViewModel<ToolModel>{
    constructor(parent:ViewModel, toolTypeId = null) {
        super(parent);
        this.toolTypeId = toolTypeId;    
    }

    public set toolTypeId(v: string) { this._toolTypeId = v; } public get toolTypeId(): string { return this._toolTypeId;} private _toolTypeId: string;
    
    protected async loadData(): Promise<ToolModel[]> {

        if(stringIsNullOrEmpty(this.toolTypeId) == true){
            return [];
        }

        let serverResult = await ServerConnection.callServer('/Complex/ToolModelServices/ListToolModelsForToolType', {
            ToolTypeId : this.toolTypeId
        });
        let toolModels = serverResult.ToolModels.map(item => {
            let toolModel = new ToolModel(this);
            toolModel.id = item.Id;
            toolModel.title = `${item.Name} (${item.Code})`;
            return toolModel;
        });
        return toolModels; 
    }
    
}


export class ToolModel extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}

